import * as THREE from 'three';

export type ModelInModelTreeInLayerEditor = {
    uuid: string;
    name: string;
    visible: boolean;
    isPartOfAModel: boolean;
    position: THREE.Vector3Tuple;
    rotation: THREE.EulerTuple;
    originalMaterial?: THREE.Material;
    children: ModelInModelTreeInLayerEditor[];
};

/**
 * 
 * @param models THREE.Object3D[]
 * @returns ModelInModelTreeInLayerEditor[]
 */
export const createModelTreeForLayerEditorAndSetUUID = (models: THREE.Object3D[]): ModelInModelTreeInLayerEditor[] => {
    return models.map(model => {
        let uuid = model.userData?.uuid;
        if (!uuid) {
            uuid = THREE.MathUtils.generateUUID();
            model.userData = { ...model.userData, uuid };
        }

        model.uuid = uuid;

        return {
            uuid,
            name: model.name,
            isPartOfAModel: true,
            visible: model.visible,
            position: [model.position.x, model.position.y, model.position.z],
            rotation: [model.rotation.x, model.rotation.y, model.rotation.z],
            originalMaterial: model.material ?? undefined,
            children: createModelTreeForLayerEditorAndSetUUID(model.children)
        };
    });
};